import { render, staticRenderFns } from "./menu-list.vue?vue&type=template&id=2b0ce268&"
import script from "./menu-list.vue?vue&type=script&lang=js&"
export * from "./menu-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0ce268')) {
      api.createRecord('2b0ce268', component.options)
    } else {
      api.reload('2b0ce268', component.options)
    }
    module.hot.accept("./menu-list.vue?vue&type=template&id=2b0ce268&", function () {
      api.rerender('2b0ce268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/store/menus/menu-list.vue"
export default component.exports